import Rollbar from 'src/analytics/rollbar';
import UserModel from 'src/models/UserModel';
import { API_V3_BASE_PATH, client } from './httpClient';

export type SubTax = {
  taxTotal: number; // in cents
  taxRate: number; // tax rate as a decimal
};

export const getTransactionTax = async (
  price: number,
  user: UserModel
): Promise<SubTax | undefined> => {
  try {
    const body = {
      accountId: user.accountId,
      price
    };

    const { headers } = user.getApiV3ReqOpts();

    const url = `${API_V3_BASE_PATH}/avalara`;

    const { data } = await client.post(url, body, { headers });

    if (!data) {
      throw new Error('No data returned');
    }

    if (typeof data.totalTax !== 'number') {
      throw new Error('No tax total returned');
    }

    return {
      taxTotal: Math.round(data.totalTax * 100),
      taxRate: data.taxRate
    };
  } catch (err) {
    Rollbar.trackError('Avalara API error', err);
    return;
  }
};
